<template>
    <vs-popup :active.sync="showValidationPopup" :title="title">
      <div class="vx-row">
        <div class="vx-col sm:w-1/2">
          <vs-button class="mt-2 w-full" @click="optionOne">{{ optionOneText }}</vs-button>
        </div>
        <div class="vx-col sm:w-1/2">
          <vs-button class="mt-2 w-full" @click="optionTwo">{{ optionTwoText }}</vs-button>
        </div>
      </div>
    </vs-popup>
</template>
<script>
export default {
	name: "ValidationPopup",
	props: {
		objToRedirect: {
			type: Object,
			default: null
		},
		title: String,
		optionOneText: String,
		optionTwoText: String,
		isActive: Boolean,
	},
	data() {
		return {
			showValidationPopup: this.$props.isActive,
		};
	},
	methods: {
		optionOne(){
			this.$emit("option-one", this.objToRedirect);
			this.showValidationPopup = false;
		},
		optionTwo(){
			this.$emit("option-two", this.objToRedirect);
			this.showValidationPopup = false;
		}
	},
};
</script>